/* eslint-disable */

import React from 'react'
import * as FileSaver from 'file-saver';
import * as XLSX from 'sheetjs-style';

const ExportVoucher = ({ excelData, fileName, totals }) => {
  const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const fileExtension = '.xlsx';

  const exportToExcel = async () => {
    // Build data array — append blank row + totals row using existing column keys
    let rows = [...excelData];

    if (totals) {
      rows.push({}); // blank separator row
      rows.push({
  "No": "SUMMARY",
  "Voucher Date": "",
  "Voucher Code": "",
  "Doctor": "",
  "Patient Name": "",
  "Test Name": "",
  "Test Qty": "",
  "Test Unit Amount": "",
  "Test Total Amount": "",
  "Qty": "",
  "Total Amount": totals.totalVoucher,
  "Discount": totals.totalDiscount,
  "Net": totals.totalCashDown,
  "Pay Amount": "",
  "Repay Amount": "",
  "Credit": totals.totalCredit,
  "Paid By": "",
  "Pay With": ""
});
    }

    const ws = XLSX.utils.json_to_sheet(rows);

    // Style the summary row
    if (totals) {
      const summaryRowNum = rows.length + 1; // +1 because header is row 1
      Object.keys(ws).forEach(cellRef => {
        const rowNum = parseInt(cellRef.replace(/[A-Z]+/, ''), 10);
        if (rowNum === summaryRowNum) {
          ws[cellRef].s = {
            font: { bold: true },
            fill: { fgColor: { rgb: 'EFF6FF' } },
          };
        }
      });
    }

    const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  }

  return (
    <>
      <button className='btn btn-md btn-success ml-2' onClick={() => exportToExcel()}>Export</button>
    </>
  )
}

export default ExportVoucher